import { IPromise } from 'angular'
import { ApiResponse, ApiSale } from '@vend/types'

import { extractData } from '../../../util/extract-data'
import { $http } from '../../../ng-compat/imports'

const SALES_ENDPOINT = '/api/2.0/sales'

/**
 * Functions for querying the sales API for sale data.
 */

/**
 * Get a specific sale by ID.
 *
 * @param  id
 *         ID of the sale to get
 *
 * @return A promise resolved with the requested sale
 */
export function get(id: string): IPromise<ApiSale> {
  return $http
    .get<ApiResponse<ApiSale>>(`${SALES_ENDPOINT}/${id}`)
    .then(extractData)
}
